import { BadgeValues } from '.';
import styles from '../index.module.css';

interface OptionBadgesProps {
  onBadgeClick?: () => void;
  optionBadge: BadgeValues;
}

/**
 * Given badge of an option, display badges and allow action on click
 */
export const OptionBadges: React.FC<OptionBadgesProps> = ({
  optionBadge,
  onBadgeClick,
}: OptionBadgesProps) => {
  return (
    <div className={styles.BadgeWrapper} onClick={onBadgeClick}>
      {optionBadge.badges.map((item) => (
        <span className={styles.Badge} key={item}>
          {item}
        </span>
      ))}
    </div>
  );
};
